import type { Program } from './programs.types'
import france from './france'
import italy from './italy'
import unieuro from './unieuro'
import germany from './germany'
import austria from './austria'

const programs: Record<string, Program> = {
  de: germany,
  at: austria,
  fr: france,
  it: italy,
  unieuro,
}

export default programs
